import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Typography from '@jobcase/react_pattern_library/components/Typography/TypographyRebrand';
import Modal from '@jobcase/react_pattern_library/components/Modal';
import styles from '@jobcase/react_pattern_library/styles/rebrand';

import { useDispatch } from 'react-redux';
import Login from '../../../../features/SSO/Login';
import Signup from '../../../../features/SSO/Signup/Signup';

import actions from '../../../../redux/nodes/authentication/actions';

import { useAppContext } from '../../../../utils/hooks';
import {
  reportOnboardingArrivedCreateAccount,
  reportOnboardingLoggedIn,
  reportOnboardingAccountCreated,
} from '../../../../utils/reporting/employerOnboardingEvents';

const HeadingTypography = styled(Typography)`
  margin: 0 0 ${styles.spacing.tiny + 2}px;
`;

const StyledModal = styled(Modal)`
  height: auto;
  margin: 25px auto auto;
  overflow: scroll; /* Makes it scrollable for IOS */
  -webkit-overflow-scrolling: touch; /* Makes it scrollable for IOS */
  padding: 0;
  position: unset;
  width: 290px;

  @media (min-width: ${styles.breakpoint.xs}) {
    width: 360px;
  }

  @media (min-width: ${styles.breakpoint.md}) {
    height: auto;
    overflow: hidden;
    width: 370px;
  }
`;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${styles.spacing.tiny}px;
`;

const CreateAccount = ({ onContinue, onFormChange, signupTitle }) => {
  const dispatch = useDispatch();
  const { isMobile } = useAppContext();
  const [isLoginVisible, setLoginVisible] = useState(false);

  useEffect(() => {
    reportOnboardingArrivedCreateAccount();
  }, []);

  const onCloseHandler = () => {
    dispatch({
      type: actions.TYPES.SET_LOGIN_ERROR,
      payload: null,
    });
    setLoginVisible(false);
  };

  const handleOnLoginSuccess = useCallback((signOnType) => {
    reportOnboardingLoggedIn(signOnType);
    onContinue();
  }, [onContinue]);

  const handleOnSignUp = useCallback((signOnType) => {
    reportOnboardingAccountCreated(signOnType);
    onContinue();
  }, [onContinue]);

  return (
    <>
      <HeadingTypography variant={Typography.VARIANTS.H1}>{signupTitle}</HeadingTypography>
      <Signup
        onSignupSuccess={handleOnSignUp}
        isLoginVisible={isLoginVisible}
        onVisibleLogin={() => setLoginVisible(true)}
        onFormChange={onFormChange}
      />
      <StyledModal
        isVisible={isLoginVisible}
        hasCloseButton={false}
        headerText={isMobile ? 'Login' : null}
        isMobile={isMobile}
        isHeaderVisible={isMobile}
        onClose={onCloseHandler}
        closeOnEscape
      >
        <ModalContent>
          <Login
            customTitle="Welcome Back to Jobcase!"
            onCreateNewAccount={onCloseHandler}
            onLoginSuccess={handleOnLoginSuccess}
          />
        </ModalContent>
      </StyledModal>
    </>
  );
};

CreateAccount.propTypes = {
  onContinue: PropTypes.func,
  onFormChange: PropTypes.func,
  signupTitle: PropTypes.string,
};

CreateAccount.defaultProps = {
  onContinue: () => {},
  onFormChange: () => {},
  signupTitle: null,
};

export default CreateAccount;
